import styled from "styled-components";
import { Button, DialogActions } from "@mui/material";
import Colors from "@src/constants/Colors";

export const CustomCardWrapper = styled.div`
  padding: 16px;
`;

export const PageWrapper = styled.div`
  padding: 20px;
`;

export const PageTitle = styled.h1`
  margin-bottom: 20px;
`;

export const PropertyContainer = styled.div`
  margin-bottom: 30px;
  border: 1px solid ${Colors.gray_300};
  border-radius: 8px;
  padding: 20px;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
  border-bottom: 1px solid ${Colors.gray_400};
`;

export const PropertyTitle = styled.h2`
  color: ${Colors.gray_800};
  margin: 0;
`;

export const CreateStoreButton = styled(Button)`
  && {
    padding: 4px 16px;
    background-color: ${Colors.primary_600};
    border: 1px solid ${Colors.primary_600};
    color: white;
    cursor: pointer;

    &:hover {
      background-color: ${Colors.primary_600};
    }
  }
`;

export const StoreContainer = styled.div`
  margin-bottom: 25px;
  background-color: ${Colors.gray_50};
  padding: 15px;
  border-radius: 5px;
`;

export const StoreHeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
`;

export const StoreTitle = styled.h3`
  color: ${Colors.gray_600};
  margin: 0;
`;

export const CreateRvcButton = styled(Button)`
  && {
    padding: 4px 16px;
    background-color: ${Colors.primary_600};
    border: 1px solid ${Colors.primary_600};
    color: white;
    cursor: pointer;

    &:hover {
      background-color: ${Colors.primary_600};
    }
  }
`;

export const TableWrapper = styled.div`
  max-height: 333px;
  overflow-y: auto;
  border: 1px solid ${Colors.gray_200};
  border-radius: 4px;
`;

export const RvcTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  background-color: white;
`;

export const TableHeader = styled.thead`
  position: sticky;
  top: -1px;
`;

export const TableHeaderCell = styled.th`
  position: sticky;
  top: 0;
  border: 1px solid ${Colors.gray_200};
  padding: 8px;
  text-align: left;
  background-color: ${Colors.gray_100};
  z-index: 1;
`;

export const TableCell = styled.td`
  border: 1px solid ${Colors.gray_200};
  padding: 8px;
`;

export const EmptyMessage = styled.p`
  font-style: italic;
  color: ${Colors.gray_700};
`;

export const ExpandStoresButton = styled(Button)`
  && {
    color: ${Colors.primary_600};
    font-weight: bold;
    font-size: 15px;
  }
`;

export const CustomDialogActions = styled(DialogActions)`
  && {
    justify-content: space-between;
    padding: 16px 24px;
  }
`;

export const CancelButton = styled(Button)`
  && {
    padding: 4px 16px;
    color: ${Colors.primary_600};
    border: 1px solid ${Colors.primary_600};
  }
`;
